import React, { useContext } from 'react';
import { IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { TeamAlertsContext } from '../../../../../../context/team-alerts-context';

const useStyles = makeStyles(() => ({
    customIcon: {
        opacity: 0,
        '&:hover': {
            backgroundColor: 'inherit',
            opacity: 0.5
        }
    }
}));

const SortIconButtonAlertType = ({ filterType }) => {
    const classes = useStyles();
    const { gridFilterOptions, setGridFilterOptions } = useContext(TeamAlertsContext);

    const handleClick = () => {
        const sortOrderValue = !(gridFilterOptions[filterType].ascendingSortOrder);
        const replacementKey = { ...gridFilterOptions[filterType] };
        replacementKey.ascendingSortOrder = sortOrderValue;

        setGridFilterOptions({ ...gridFilterOptions, [filterType]: replacementKey });
    }

    const ArrowIcon = () => {
        if (gridFilterOptions[filterType]) {
            if (gridFilterOptions[filterType].ascendingSortOrder) {
                return <ArrowUpwardIcon style={{ fontSize: 18 }}/>;
            }
        }

        return <ArrowDownwardIcon style={{ fontSize: 18 }} />;
    }

    return <IconButton className={classes.customIcon} onClick={handleClick}>{ArrowIcon()}</IconButton>;
}

SortIconButtonAlertType.propTypes = {
    filterType: PropTypes.string.isRequired
}

export default SortIconButtonAlertType;
